/// <reference path="DOMAttached.js" />

class MiniWorldExitButton extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.safeObserve(document.getElementById(this.options.exitButtonId), 'click', this.onClick.bind(this));
	}

	onClick() {
		var gradXtable = document.getElementById('gradXtable');
		if (gradXtable && !gradXtable.classList.contains("hidden")) {
			// If gradXtable is not hidden, we want to hide it first.
			gradXtable.classList.add("hidden");
		} else {
			window.location = this.options.worldUrl;
		}
	}
}
